import {get} from "../utils";

export default host => (params) =>
  get(`${host}/tags/downloadLink${params ? `${params}` : '' }`)
    .then(response => response.text())
